const PREVIEW_DAYS = 7;

export function generatePreviewTokenFields() {
    return {
        previewToken: crypto.randomUUID(),
        previewTokenExpires: Date.now() + PREVIEW_DAYS * 24 * 60 * 60 * 1000,
    };
}

export function isPreviewTokenValid(project, token) {
    if (!project || !token || !project.previewToken) return false;
    if (project.previewToken !== token) return false;
    const exp = project.previewTokenExpires || 0;
    return Date.now() < exp;
}

export function buildPreviewShareUrl(projectId, token) {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/#page=fund&project=${encodeURIComponent(projectId)}&view=preview&token=${encodeURIComponent(token)}`;
}

export function previewExpiresLabel(project) {
    if (!project?.previewTokenExpires) return '';
    return new Date(project.previewTokenExpires).toLocaleString();
}
